import { api } from "../api";

/**
 * findAllGroupsExportResponse - Function that finds on database all groups by department and status and then exports in a PDF/XSLX file  
 * /groups/{customerId}/{departmentId}/{status}/{exportType}  
 * method GET  
 * @async-function
 */
const findAllGroupsExportResponse = async (token: string, customerId: number, departmentId: number, status: string, exportType: string, ignoreDepartments: Boolean = false, simpleXlsxExport = false) => {
    const response = await api.get(
        `/groups/${customerId}/${departmentId}/${status}/${exportType}/export?ignoreDepartments=${ignoreDepartments}&simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllGroupsExportResponse;